import { useConnection } from 'wagmi';
import { mainnet } from 'wagmi/chains';

import { ChainContracts, getVaultContracts } from '@/app/shared/constants/web3/chainContracts';

export const resolveVaultChainId = (
  vaultAddress?: string,
  preferredChainId?: number,
): number | undefined => {
  if (preferredChainId != null && getVaultContracts(preferredChainId, vaultAddress)) {
    return preferredChainId;
  }

  if (vaultAddress && getVaultContracts(mainnet.id, vaultAddress)) return mainnet.id;
  return preferredChainId;
};

export const useVaultChainId = (vaultAddress?: string): number | undefined => {
  const { chainId } = useConnection();
  return resolveVaultChainId(vaultAddress, chainId);
};

export const useChainContracts = (vaultAddress?: string): ChainContracts | undefined => {
  const chainId = useVaultChainId(vaultAddress);
  return getVaultContracts(chainId, vaultAddress);
};
